import React, { useEffect, useState, useRef } from "react";
import Link from "next/link";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import ActionCreators from "../../store/ActionCreators";
import ReCAPTCHA from "react-google-recaptcha";
import {useRouter} from 'next/router';

import {
  CustomTextInput,
  CustomButton,
  CustomHeader,
  CustomModal
} from "../../components/commons";

import {
  isValidRequiredField,
  isValidEmail,
  renderRequiredError,
  renderInvalidEmailError,
} from "../../helpers/form";

import { apiResponseStatuses } from "../../config/constants/ApiServiceConstants";
import { preAuthPaths } from '../../config/constants/NavigationConstants'
import {
  isSameAs,
  isValidPassword,
  renderPasswordError,
  renderSameAsError,
  renderTCError,
} from "../../helpers/form/Validator";
import { SIGN_UP } from "../../store/signUp/Types";
import ReCaptcha from "../../config/constants/recaptcha-key";

import styles from './Signup.module.css';

const mapStateToProps = (state) => ({
  signUpReducer: state.signUpReducer,
  auth: state.authReducer,
  treesReducer: state.treesReducer,
});

const mapDispatchTopProps = (dispatch) =>
  bindActionCreators(ActionCreators, dispatch);

const connector = connect(mapStateToProps, mapDispatchTopProps);

const Signup = ({ ...props }) => {
  const { signUpReducer, auth, signUp, treesReducer } = props;
  const { isLoading, responseStatus, message, type } = signUpReducer;
  const authReducer = auth;
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();

  const {
    urlApiSource,
    urlSelectedTreeCount,
    urlTransactionId,
    urlEmailId,
  } = treesReducer;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState(urlEmailId || "");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSignUpSuccess, setIsSignUpSuccess] = useState(false);
  const [TC, setTC] = useState(false);

  const history = useRouter();

  /**
   * All refs initialized here
   */
  const reRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const emailRef = useRef();
  
  useEffect(() => {
    if (responseStatus === apiResponseStatuses.SUCCESS && isSubmitted) {
      navigateToSuccessPage();
    }
  }, [responseStatus]);

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const navigateToSuccessPage = () => {
    console.log('going');
    history.push(`${preAuthPaths.MESSAGE}/signup`);
    // console.log('Navigating to success page');
	}

  const submit = async () => {
    const reCaptcha_token = await reRef.current.executeAsync();
    // reRef.current.reset();
    doValidate(reCaptcha_token);
  };

  const doValidate = async (reCaptcha_token) => {
    setIsSubmitted(true);
    if (
      isValidRequiredField(firstName, isSubmitted) &&
      isValidRequiredField(lastName, isSubmitted) &&
      isValidRequiredField(email, isSubmitted) &&
      isValidRequiredField(password, isSubmitted) &&
      isValidRequiredField(confirmPassword, isSubmitted) &&
      isSameAs(confirmPassword, isSubmitted, password) &&
      isValidEmail(email) &&
      isValidPassword(password, isSubmitted)
    ) {
      // signup function called when all the validation is successful
      // if there are pending transactions then signup function should
      // be called with transactional data too
      if (TC == true) {
        if (urlApiSource) {
          if (urlApiSource === "restaurant") {
            // for transaction_system panacea, count and transaction_id not
            // required
            signUp({
              firstName,
              lastName,
              email,
              password,
              confirmPassword,
              reCaptcha_token,
              transactionDetail: {
                transaction_system: urlApiSource,
              },
            });
          } else {
            // for transaction_system sustainable_meeting, count and transaction_id is
            // required

            // before signing up using this, ensure the mail for which the transaction was
            // enabled is the same as the one input in the form
            if(urlEmailId.trim() == email.trim()) {
              signUp({
                firstName,
                lastName,
                email,
                password,
                confirmPassword,
                reCaptcha_token,
                transactionDetail: {
                  transaction_system: urlApiSource,
                  count: urlSelectedTreeCount,
                  transaction_id: urlTransactionId,
                },
              });
            }else {
              // just signup with no passed parameters for transactions
              signUp({
                firstName,
                lastName,
                email,
                password,
                reCaptcha_token,
                confirmPassword,
              });
            }
          }
        } else {
          // just signup with no passed parameters for transactions
          signUp({
            firstName,
            lastName,
            email,
            password,
            reCaptcha_token,
            confirmPassword,
          });
        }
      } else {
        console.log("object");
      }
    }
  };

  if (isLoading || authReducer.isLoading) {
    return <span>Loading...</span>;
  }

  const renderAPIError = () => {
    if (responseStatus === apiResponseStatuses.ERROR && type === SIGN_UP) {
      return <span className="alert-danger">{message}</span>;
    }

    return "";
  };

  const renderSignUpSuccess = () => {
    // if (isSignUpSuccess) {
    //   return (
    //     <span className="alert-success">
    //       Please click the confirmation link sent to your email address to
    //       login.
    //     </span>
    //   );
    // }

    return "";
  };

  const changePasswordFieldType = (e) => {
    if (passwordRef.current.type === "password") {
      passwordRef.current.type = "text";
      e.target.setAttribute("src", "./images/visibility.png");
    } else {
      passwordRef.current.type = "password";
      e.target.setAttribute("src", "./images/invisible.png");
    }
  };

  const changeConfirmPasswordFieldType = (e) => {
    if (confirmPasswordRef.current.type === "password") {
      confirmPasswordRef.current.type = "text";
      e.target.setAttribute("src", "./images/visibility.png");
    } else {
      confirmPasswordRef.current.type = "password";
      e.target.setAttribute("src", "./images/invisible.png");
    }
  };

  return (
    <section className="banner-sec signup-sec">
      {/* <CustomHeader /> */}

      <div className="container-wrap">
        <div className="inner-wrap">
          <div className="cmn-head">
            <h2>Sign up to GiftTrees</h2>
            <p>
              Great! you now just need to sign up to add your tree to your
              forest.
            </p>
            {renderAPIError()}
            {renderSignUpSuccess()}
          </div>
          {/* {!isSignUpSuccess ? ( */}
            <form className="custom-form">
              <CustomTextInput
                onChange={(e) => setFirstName(capitalizeFirstLetter(e.target.value))}
                placeholder="First name"
                defaultValue={firstName}
                inputRef={firstNameRef}
                enableError={false}
              />
              {renderRequiredError(
                firstName,
                isSubmitted,
                "The first name is required."
              )}
              <CustomTextInput
                onChange={(e) => setLastName(capitalizeFirstLetter(e.target.value))}
                placeholder="Last Name"
                defaultValue={lastName}
                inputRef={lastNameRef}
                enableError={false}
              />
              {renderRequiredError(
                lastName,
                isSubmitted,
                "The last name is required."
              )}
              <CustomTextInput
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
                placeholder="Email Address"
                defaultValue={email}
                inputRef={emailRef}
                inputStyle={{textTransform: 'lowercase'}}
                id={'emailField'}
                enableError={false}
              />
              {renderRequiredError(
                email,
                isSubmitted,
                "The email is required."
              )}
              {renderInvalidEmailError(email, isSubmitted)}
              {/* <CustomTextInput 
                                onChange={ (e) => setPassword(e.target.value) }
                                placeholder="Password" type="password"/>*/}

              <div className="signup-password-field">
                <div
                  className="form-group"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="password"
                    ref={passwordRef}
                    placeholder="PASSWORD"
                    onChange={(e) => setPassword(e.target.value)}
                    defaultValue={password}
                  />
                </div>
                {password.length > 0 ? (
                  <button type="button">
                    <img
                      alt="Password Visible"
                      src="../images/invisible.png"
                      onClick={(e) => changePasswordFieldType(e)}
                    />
                  </button>
                ) : null}
              </div>
              {renderRequiredError(
                password,
                isSubmitted,
                "The password is required."
              )}
              {renderPasswordError(password, isSubmitted)}
              {/* <CustomTextInput
                                onChange={ (e) => setConfirmPassword(e.target.value) }
                                placeholder="Confirm Password" type="password"/> */}
              <div className="signup-password-field">
                <div
                  className="form-group"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="password"
                    ref={confirmPasswordRef}
                    placeholder="CONFIRM PASSWORD"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    defaultValue={confirmPassword}
                  />
                </div>
                {confirmPassword.length > 0 ? (
                  <button type="button">
                    <img
                      alt="Password InVisible"
                      src="../images/invisible.png"
                      onClick={(e) => changeConfirmPasswordFieldType(e)}
                    />
                  </button>
                ) : null}
              </div>
              {renderRequiredError(
                confirmPassword,
                isSubmitted,
                "The confirm password is required."
              )}
              {renderSameAsError(
                confirmPassword,
                isSubmitted,
                password,
                "Confirm password",
                "password"
              )}
              <div className="chk-box">
                <input
                  className="checkbox"
                  type="checkbox"
                  id="checkbox"
                  name="checkbox"
                  checked={TC}
                  onChange={() => {
                    setTC(!TC);
                  }}
                />
                <span className="chk-span">
                  I agree to the{" "}
                  <a href="https://www.sustainably.run/terms" target="_blank">
                    <strong>Terms of Service </strong>
                  </a>{" "}
                  and acknowledge the{" "}
                  <a
                    href="https://www.sustainably.run/privacy-policy"
                    target="_blank"
                  >
                    <strong>Privacy Policy</strong>
                  </a>
                  .
                </span>
              </div>
              {/* {renderRequiredError(TC, isSubmitted, "check it.")} */}
              {renderTCError(TC, isSubmitted, "required")}
              <div className="btn-wrp">
                <CustomButton
                  onClick={() => submit()}
                  className="cmn-btn"
                  name="Sign Up"
                />
                <ReCAPTCHA
                  sitekey={ReCaptcha.public_key}
                  size="invisible"
                  ref={reRef}
                />
                <span className="login-link">
                  Already registered?
                  <Link href="/login">
                    <strong className="signup-login-link pointer">
                      {" "}
                      LOG IN
                    </strong>
                  </Link>
                </span>
              </div>
            </form>
          {/* ) : null} */}
        </div>
      </div>
    </section>
  );
};

Signup.defaultProps = {
  auth: {},
  signUpReducer: {},
  signUp: null,
  treesReducer: {},
};

Signup.propTypes = {
  auth: PropTypes.instanceOf(Object),
  signUpReducer: PropTypes.instanceOf(Object),
  signUp: PropTypes.func,
  treesReducer: PropTypes.instanceOf(Object),
};

export default connector(Signup);
